'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _NoResults = require('./NoResults.scss');

var _NoResults2 = _interopRequireDefault(_NoResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoResults = function (_Component) {
    (0, _inherits3.default)(NoResults, _Component);

    function NoResults() {
        (0, _classCallCheck3.default)(this, NoResults);
        return (0, _possibleConstructorReturn3.default)(this, (NoResults.__proto__ || (0, _getPrototypeOf2.default)(NoResults)).apply(this, arguments));
    }

    (0, _createClass3.default)(NoResults, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['children']);
        }
    }, {
        key: 'render',
        value: function render() {
            var children = this.props.children;

            return (0, _jsx3.default)('div', {
                className: _NoResults2.default['no-results-container']
            }, void 0, children);
        }
    }]);
    return NoResults;
}(_react.Component);

exports.default = NoResults;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Pagination/NoResults.js
// module id = 7oIq
// module chunks = 57